
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import descriptor from './GisDocumentDesignerDataset&LayerDescriptor.json'
import styleDescriptor from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesignerDescriptor.json'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'

const deepcopy = require('deepcopy')

export default defineComponent({
    components: {
        DataTable,
        Column,
        Dialog
    },
    emits: ['datasetDeleted', 'datasetChanged'],
    props: { documentDataProp: { type: Object as any, required: false }, isDatasetChosen: Object },
    computed: {},
    data() {
        return {
            descriptor,
            styleDescriptor,
            columns: descriptor.datasetColumns,
            globalFilterFields: descriptor.datasetFilterFields,
            filters: { global: [filterDefault] } as Object,
            loading: false,
            datasetDialogVisible: false,
            availableDatasets: [] as any,
            selectedDataset: {} as any,
            documentData: {} as any
        }
    },
    created() {
        this.documentData = this.documentDataProp
    },
    methods: {
        showDatasetDialog() {
            this.$confirm.require({
                header: this.$t('common.toast.warning'),
                message: this.$t('workspace.gis.dnl.changeDsMessage'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.openDatasetDialog()
                }
            })
        },
        openDatasetDialog() {
            this.selectedDataset = deepcopy(this.documentData.selectedDataset[0])
            this.datasetDialogVisible = true
            this.getAllDatasets()
        },
        async getAllDatasets() {
            this.loading = true
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/datasets/mydatanoparams`).then((response: AxiosResponse<any>) => (this.availableDatasets = response.data.root))
            this.loading = false
        },
        closeDialog() {
            this.filters['global'].value = null
            this.datasetDialogVisible = false
        },
        deleteSelectedDataset() {
            this.documentData.selectedDataset = []
            this.documentData.datasetLabel = ''
            this.$emit('datasetDeleted')
        },
        saveDatasetSelection() {
            this.documentData.selectedDataset[0] = deepcopy(this.selectedDataset)
            this.$emit('datasetChanged', this.selectedDataset)
            this.datasetDialogVisible = false
        }
    }
})
